import routerOptions0 from "/home/runner/work/genoch-mercato-client-dashboard/genoch-mercato-client-dashboard/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}